<template>
  <div>
    <v-row>
      <v-col
        cols="4"
        v-for="(item, i) in bankAccounsData"
        :key="i"
        style="padding: 2px"
      >
        <div class="container mt-5 justify-content-center">
          <div class="card p-3">
            <div class="d-flex align-items-center">
              <div class="image">
                <img
                  src="@/assets/bank.png"
                  class="rounded"
                  width="155"
                  style="padding: 8px"
                />
              </div>
              <div class="ml-3 w-150" style="padding-top: 8px">
                <h2 class="mb-0 mt-0">{{ item.account_number }}</h2>
                <span>{{ item.type }}</span>
                <div
                  class="p-2 mt-2 bg-primary d-flex justify-content-between rounded text-white stats"
                  style="width: 200px"
                >
                  <span style="padding: 3px">
                    <b
                      >Balance :{{ item.actual_amount | formatCurrency }}</b
                    ></span
                  >
                </div>
                <div
                  class="button d-flex flex-row align-items-center"
                  style="margin-left: -19px; margin-top: 6px"
                >
                  <v-btn
                    class="ma-2"
                    outlined
                    color="primary"
                    @click="EditBankAccount(item)"
                  >
                    Edit
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    color="primary"
                    @click="selectedBankbookAccount(item)"
                  >
                    Select
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="4" style="padding: 2px">
        <CreateNew @CreatePopup="openCreateModal" />
      </v-col>
      <CreatePopup
        ref="bankaccount"
        :bankDetails="bankdata"
        :bankAccountID="bankAccountID"
        @afterSave="refreshModule"
      />
      <EditPopup
        ref="Editbankaccount"
        :bankDetails="bankdata"
        :bankAccount="bankAccountID"
        @afterSave="refreshModule"
      />
    </v-row>
  </div>
</template>
<script>
import CreateNew from './CreateNewAccount.vue';
import CreatePopup from './BankAccountPopup.vue';
import EditPopup from './EditBankAccountPopup.vue';

import axios from '@/plugins/axios';
export default {
  data: () => ({
    bankAccounsData: [],
    bankAccountID: null,
  }),
  props: {
    bankdata: {
      type: Object,
      default: null,
    },
  },
  created() {
    this.GetBankAccountsDetails();
  },
  components: {
    CreateNew,
    CreatePopup,
    EditPopup,
  },
  methods: {
    openCreateModal() {
      this.$refs.bankaccount.openModal();
    },
    EditBankAccount(data) {
      this.bankAccountID = data.id;
      this.$refs.Editbankaccount.openModal();
    },
    refreshModule() {
      setTimeout(() => {
        this.GetBankAccountsDetails();
      }, 40);
    },
    selectedBankbookAccount(data) {
      this.$emit('selectedBankAccount', data);
    },
    GetBankAccountsDetails() {
      axios
        .get(`bank-account?bank=${this.bankdata.id}`)
        .then((res) => {
          this.bankAccounsData = res.data.rows;
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped>
body {
  background-color: #b3e5fc;
  border-radius: 10px;
}

.card {
  width: 400px;
  border: none;
  border-radius: 10px;
  background-color: #fff;
}

.stats {
  background: #f2f5f8 !important;
  color: #000 !important;
}

.articles {
  font-size: 10px;
  color: #a1aab9;
}

.number1 {
  font-weight: 500;
}

.followers {
  font-size: 10px;
  color: #a1aab9;
}

.number2 {
  font-weight: 500;
}

.rating {
  font-size: 10px;
  color: #a1aab9;
}

.number3 {
  font-weight: 500;
}
</style>
